import * as React from 'react';
import { Button, Grid, Dropdown, Popup, Icon } from 'semantic-grab-ui/src';
import * as _ from "lodash";
import { renderDropdownItem } from './util';

interface AddNodeDropdownProps {
  choices: string[], // list of node types
  handleAddNode: Function,
  currentNodeKey: string,
  subScenarioIndex?: number, // the index of the new sub scenario if we are to add one
}

// AddNodeDropdown is the dropdown for adding node after a node
export default class AddNodeDropdown extends React.Component<AddNodeDropdownProps> {
  getChoiceText = (choice: string) => {
    return `Add ${_.startCase(choice)}`;
  };

  render() {
    const { choices, currentNodeKey, subScenarioIndex } = this.props;
    const addButtonSize = {
      fontSize: '1.5em',
      color: '#3498DB',
    };

    return (
      <Dropdown icon="plus square" floating basic className="icon" style={addButtonSize}>
        <Dropdown.Menu>
          {
            _.map(choices, (choice) => {
              if (!_.isEmpty(choice)) {
                return renderDropdownItem(
                  this.getChoiceText(choice),
                  () => this.props.handleAddNode(choice,
                    currentNodeKey,
                    [currentNodeKey],
                  )
                )
              }
            })
          }
        </Dropdown.Menu>
      </Dropdown>
    )
  }
}
